export const isYouTubeURL = (value: string) => {
  const regex = /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/
  return regex.test(value)
}
